(function ($) {
    ("use strict");
    const menuOpenButton = $(".menu-toggle");
    const menuCloseButton = $(".menu-close");
    const menuOverlay = $(".overlay");

    menuOpenButton.on("click touchstart", function (e) {
        e.preventDefault();
        $("body").addClass("menu-active");
    });

    menuCloseButton.on("click touchstart", function (e) {
        e.preventDefault();
        $("body").removeClass("menu-active");
    });

    menuOverlay.on("click touchstart", function (e) {
        e.preventDefault();
        $("body").removeClass("menu-active");
    });

    $(".mobile-menu li a").on("click touchstart", function (e) {
        $("body").removeClass("menu-active");
    });
})(jQuery);
